import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, Transition as _Transition, createBlock as _createBlock, normalizeStyle as _normalizeStyle, toHandlers as _toHandlers } from "vue"

const _hoisted_1 = { class: "user-container" }
const _hoisted_2 = { class: "cropper" }
const _hoisted_3 = { class: "cropper-top" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_5 = { class: "cropper-body" }
const _hoisted_6 = {
  key: 0,
  class: "no-image"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-search" }, null, -1)
const _hoisted_8 = { class: "cropper-crop" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "cropper-actions" }
const _hoisted_11 = { class: "dialog-card warning" }
const _hoisted_12 = { class: "dialog-title" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-exclamation-triangle" }, null, -1)
const _hoisted_14 = { class: "dialog-actions" }
const _hoisted_15 = { style: {"margin-left":"auto","display":"flex"} }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "dialog-bottom" }, null, -1)
const _hoisted_17 = { class: "admin-top" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-left" }, null, -1)
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { style: {"margin-left":"auto"} }, null, -1)
const _hoisted_22 = { style: {"display":"flex","align-items":"center","gap":"15px"} }
const _hoisted_23 = {
  key: 0,
  class: "options-menu"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-ellipsis-h" }, null, -1)
const _hoisted_25 = {
  key: 0,
  class: "options-menu-inner animated-fast"
}
const _hoisted_26 = { class: "admin-stage" }
const _hoisted_27 = {
  key: 0,
  class: "user-top",
  style: {"border-left":"4px solid #fec552"}
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-exclamation-triangle icon" }, null, -1)
const _hoisted_29 = { class: "content" }
const _hoisted_30 = { class: "deny-approve-title" }
const _hoisted_31 = { class: "user-detail-item" }
const _hoisted_32 = {
  key: 0,
  class: "user-detail-item"
}
const _hoisted_33 = { class: "actions" }
const _hoisted_34 = { class: "user-top" }
const _hoisted_35 = { class: "user-image" }
const _hoisted_36 = {
  key: 0,
  class: "fa fa-user"
}
const _hoisted_37 = { key: 1 }
const _hoisted_38 = {
  key: 1,
  class: "user-avatar"
}
const _hoisted_39 = ["src"]
const _hoisted_40 = {
  key: 2,
  class: "user-avatar"
}
const _hoisted_41 = { class: "user-details" }
const _hoisted_42 = { class: "column" }
const _hoisted_43 = {
  key: 0,
  class: "user-email-input"
}
const _hoisted_44 = {
  key: 1,
  class: "user-detail-item"
}
const _hoisted_45 = { class: "user-detail-item-value email-detail-item" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-envelope" }, null, -1)
const _hoisted_47 = { class: "user-name-input" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-divider" }, null, -1)
const _hoisted_49 = { class: "column" }
const _hoisted_50 = {
  key: 1,
  class: "user-detail-item"
}
const _hoisted_51 = { class: "user-detail-item-value" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-user-tag" }, null, -1)
const _hoisted_53 = { class: "user-detail-item" }
const _hoisted_54 = {
  key: 0,
  class: "site-tag tag-active"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-divider" }, null, -1)
const _hoisted_56 = { class: "column" }
const _hoisted_57 = { class: "user-detail-item" }
const _hoisted_58 = { class: "user-detail-item-value user-id-label" }
const _hoisted_59 = { class: "user-detail-item" }
const _hoisted_60 = {
  key: 0,
  class: "user-detail-item-value"
}
const _hoisted_61 = {
  key: 1,
  class: "user-detail-item-value"
}
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "vertical-divider" }, null, -1)
const _hoisted_63 = { class: "column" }
const _hoisted_64 = { class: "user-detail-item" }
const _hoisted_65 = { class: "user-detail-item-value auth0-user-label" }
const _hoisted_66 = {
  key: 0,
  class: "imdex-only-placeholder"
}
const _hoisted_67 = { key: 1 }
const _hoisted_68 = {
  key: 1,
  class: "role-icon"
}
const _hoisted_69 = {
  key: 0,
  class: "fa fa-check-circle"
}
const _hoisted_70 = {
  key: 1,
  class: "fal fa-times"
}
const _hoisted_71 = {
  key: 0,
  class: "imdex-only-placeholder"
}
const _hoisted_72 = { key: 1 }
const _hoisted_73 = {
  key: 1,
  class: "role-icon"
}
const _hoisted_74 = {
  key: 0,
  class: "fa fa-check-circle"
}
const _hoisted_75 = {
  key: 1,
  class: "fal fa-times"
}
const _hoisted_76 = {
  key: 0,
  class: "imdex-only-placeholder"
}
const _hoisted_77 = { key: 1 }
const _hoisted_78 = {
  key: 1,
  class: "role-icon"
}
const _hoisted_79 = {
  key: 0,
  class: "fa fa-check-circle"
}
const _hoisted_80 = {
  key: 1,
  class: "fal fa-times"
}
const _hoisted_81 = { class: "sitename-span" }
const _hoisted_82 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_imdex_btn = _resolveComponent("imdex-btn")!
  const _component_imdex_dialog = _resolveComponent("imdex-dialog")!
  const _component_imdex_spinner = _resolveComponent("imdex-spinner")!
  const _component_imdex_text_field = _resolveComponent("imdex-text-field")!
  const _component_imdex_select = _resolveComponent("imdex-select")!
  const _component_imdex_radio = _resolveComponent("imdex-radio")!
  const _component_imdex_tooltip = _resolveComponent("imdex-tooltip")!
  const _component_imdex_table = _resolveComponent("imdex-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("input", {
      ref: "avatar-image",
      style: {"opacity":"0","pointer-events":"none","position":"absolute","user-select":"none"},
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileChange && _ctx.onFileChange(...args)))
    }, null, 544),
    _createVNode(_component_imdex_dialog, {
      value: _ctx.cropperDialog,
      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.cropperDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_imdex_btn, {
              style: {"margin-left":"auto"},
              icon: "",
              text: "",
              compact: "",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.cropperDialog = false))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.url == '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _hoisted_7,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("userProfile.browse")), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("img", {
                ref: "cropper-image",
                src: _ctx.previewUrl != '' ? _ctx.previewUrl : _ctx.url
              }, null, 8, _hoisted_9), [
                [_vShow, false]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_imdex_btn, {
              small: "",
              text: "",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.cropperDialog = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("userProfile.cancel")), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_imdex_btn, {
              small: "",
              onClick: _ctx.finishCrop
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("userProfile.confirm")), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createVNode(_component_imdex_dialog, {
      value: _ctx.userDeleteDialog,
      "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.userDeleteDialog) = $event)),
      width: "600"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("userProfile.confirmDelete")), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.userDeleteDialog = false)),
                text: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("userProfile.cancel")), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_imdex_btn, {
                style: {"margin-left":"10px"},
                onClick: _ctx.deleteUser
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("userProfile.delete")), 1)
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _hoisted_16
        ])
      ]),
      _: 1
    }, 8, ["value"]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_imdex_btn, {
        style: {"margin-right":"15px","font-size":"25pt"},
        onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goBack())),
        text: "",
        compact: "",
        secondary: ""
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      }),
      (!_ctx.editing)
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(_ctx.$t("userProfile.create")), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t("userProfile.edit")), 1)),
      _createTextVNode(" " + _toDisplayString(_ctx.$t("userProfile.user")) + " ", 1),
      _hoisted_21,
      _createElementVNode("div", _hoisted_22, [
        (_ctx.editing)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_imdex_btn, {
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showOption = !_ctx.showOption)),
                icon: "",
                text: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_24
                ]),
                _: 1
              }),
              _createVNode(_Transition, {
                "enter-active-class": "fadeInUp",
                "leave-active-class": "fadeOutDown"
              }, {
                default: _withCtx(() => [
                  (_ctx.showOption)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                        (_ctx.isAdmin && _ctx.user.isActive == false)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.activateUser && _ctx.activateUser(...args))),
                              class: "option-menu-item"
                            }, _toDisplayString(_ctx.$t("userProfile.activateUser")), 1))
                          : _createCommentVNode("", true),
                        (_ctx.isAdmin && _ctx.user.isActive == true)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 1,
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.deactivateUser && _ctx.deactivateUser(...args))),
                              class: "option-menu-item"
                            }, _toDisplayString(_ctx.$t("userProfile.deactivateUser")), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", {
                          class: _normalizeClass([{ disabled: _ctx.authUser.id != _ctx.$route.params.id }, "option-menu-item"]),
                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$router.push(`/reset-password?userId=${_ctx.$route.params.id}`)))
                        }, _toDisplayString(_ctx.$t("userProfile.resetPassword")), 3)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]))
          : _createCommentVNode("", true),
        (!_ctx.editing)
          ? (_openBlock(), _createBlock(_component_imdex_btn, {
              key: 1,
              onClick: _ctx.submitCreateUser,
              secondary: "",
              loading: _ctx.createLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("userProfile.create")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]))
          : _createCommentVNode("", true),
        (_ctx.editing)
          ? (_openBlock(), _createBlock(_component_imdex_btn, {
              key: 2,
              onClick: _ctx.submitEditUser,
              secondary: "",
              loading: _ctx.createLoading
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("userProfile.save")), 1)
              ]),
              _: 1
            }, 8, ["onClick", "loading"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      (_ctx.user.isActive == null && _ctx.user.isAccessRequested)
        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("userProfile.accessRequestTitle")), 1),
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t("userProfile.accessRequestHint")), 1),
              (!_ctx.hasAnySiteEnabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.$t("userProfile.accessRequestRequirement")), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.approvePending,
                loading: _ctx.denyPending,
                onClick: _ctx.denyUser,
                outlined: "",
                small: "",
                secondary: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("userProfile.deny")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"]),
              _createVNode(_component_imdex_btn, {
                disabled: _ctx.denyPending || !_ctx.hasAnySiteEnabled,
                loading: _ctx.approvePending,
                onClick: _ctx.approveUser,
                small: "",
                secondary: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("userProfile.approve")), 1)
                ]),
                _: 1
              }, 8, ["disabled", "loading", "onClick"])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, [
          (_ctx.user.profilePicUrl == null && _ctx.previewUrl == '')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: _normalizeClass([{
							'has-default-color':
								_ctx.user.defaultProfilePicColor != null || _ctx.user.name != ''
						}, "user-avatar"]),
                style: _normalizeStyle(`background:${_ctx.user.defaultProfilePicColor}`)
              }, [
                (_ctx.user.name == null || _ctx.user.name == '')
                  ? (_openBlock(), _createElementBlock("i", _hoisted_36))
                  : _createCommentVNode("", true),
                (_ctx.user.name != null && _ctx.user.name.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(_ctx.user.name[0].toUpperCase()), 1))
                  : _createCommentVNode("", true)
              ], 6))
            : (
							(!_ctx.avatarLoading && _ctx.user.profilePicUrl != null) || _ctx.previewUrl != ''
						)
              ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                  _createElementVNode("img", {
                    id: "profile-pic",
                    src: _ctx.previewUrl != '' ? _ctx.previewUrl : _ctx.profilePicMap[_ctx.user.profilePicUrl],
                    alt: ""
                  }, null, 8, _hoisted_39)
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                  _createVNode(_component_imdex_spinner, {
                    size: "2",
                    width: "50"
                  })
                ])),
          (_ctx.editing && _ctx.isMe)
            ? (_openBlock(), _createBlock(_component_imdex_btn, {
                key: 3,
                onClick: _ctx.changeAvatar,
                text: "",
                secondary: "",
                compact: ""
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("userProfile.change")), 1)
                ]),
                _: 1
              }, 8, ["onClick"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            (!_ctx.editing)
              ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                  _createVNode(_component_imdex_text_field, {
                    style: {"max-width":"300px"},
                    value: _ctx.user.email,
                    "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.user.email) = $event)),
                    label: _ctx.$t(`userProfile.emailInputLabel`)
                  }, null, 8, ["value", "label"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("userProfile.email")), 1),
                  _createElementVNode("span", _hoisted_45, [
                    _hoisted_46,
                    _createTextVNode(_toDisplayString(_ctx.user.email), 1)
                  ])
                ])),
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_imdex_text_field, {
                style: {"max-width":"300px"},
                value: _ctx.user.name,
                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.user.name) = $event)),
                label: _ctx.$t(`userProfile.nameInputLabel`)
              }, null, 8, ["value", "label"])
            ])
          ]),
          _hoisted_48,
          _createElementVNode("div", _hoisted_49, [
            (_ctx.isAdmin)
              ? (_openBlock(), _createBlock(_component_imdex_select, {
                  key: 0,
                  style: {"max-width":"300px"},
                  items: _ctx.availableRoles,
                  value: _ctx.roleSelect,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.roleSelect) = $event)),
                  label: _ctx.$t(`userProfile.roleInputLabel`)
                }, null, 8, ["items", "value", "label"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_50, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("userProfile.role")), 1),
                  _createElementVNode("span", _hoisted_51, [
                    _hoisted_52,
                    _createTextVNode(_toDisplayString(_ctx.roleSelect), 1)
                  ])
                ])),
            _createElementVNode("div", _hoisted_53, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t("userProfile.status")), 1),
              _createElementVNode("span", null, [
                (_ctx.user.isActive)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, _toDisplayString(_ctx.$t(`userProfile.active`)), 1))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["site-tag tag-inactive", { 'tag-pending': _ctx.user.isActive == null }])
                    }, _toDisplayString(_ctx.user.isActive == null
											? _ctx.$t(`userProfile.pendingActivation`)
											: _ctx.$t(`userProfile.inactive`)), 3))
              ])
            ])
          ]),
          _hoisted_55,
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`userProfile.id`)), 1),
              _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.user.id), 1)
            ]),
            _createElementVNode("div", _hoisted_59, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`userProfile.lastLogin`)), 1),
              (_ctx.user.lastLoggedIn != null)
                ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(_ctx.moment(_ctx.user.lastLoggedIn)
										.locale(_ctx.i18n.global.locale)
										.tz(_ctx.moment.tz.guess())
										.fromNow()), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_61, _toDisplayString(_ctx.$t(`userProfile.n/a`)), 1))
            ])
          ]),
          _hoisted_62,
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("div", _hoisted_64, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t(`userProfile.auth0User`)), 1),
              _createElementVNode("span", _hoisted_65, _toDisplayString(_ctx.user.isAuth0User ? _ctx.$t(`userProfile.yes`) : _ctx.$t(`userProfile.no`)), 1)
            ])
          ])
        ])
      ]),
      (_ctx.editing)
        ? (_openBlock(), _createBlock(_component_imdex_table, {
            key: 1,
            loading: _ctx.tableLoading,
            tableData: _ctx.siteData,
            class: "elevate admin-table-container"
          }, {
            "h-site": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`userProfile.site`)), 1)
            ]),
            "h-contributor": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`userProfile.contributor`)), 1)
            ]),
            "h-viewer": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`userProfile.viewer`)), 1)
            ]),
            "h-none": _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t(`userProfile.none`)), 1)
            ]),
            contributor: _withCtx((prop) => [
              (prop.row.isSysAdminOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_66, "-"))
                : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_imdex_radio, {
                          key: 0,
                          onInput: ($event: any) => (_ctx.updateSitePermission(prop.row, 'contributor')),
                          value: prop.row.contributor,
                          "onUpdate:value": ($event: any) => ((prop.row.contributor) = $event)
                        }, null, 8, ["onInput", "value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_68, [
                          (prop.row.contributor)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_69))
                            : (_openBlock(), _createElementBlock("i", _hoisted_70))
                        ]))
                  ]))
            ]),
            viewer: _withCtx((prop) => [
              (prop.row.isSysAdminOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_71, "-"))
                : (_openBlock(), _createElementBlock("div", _hoisted_72, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_imdex_radio, {
                          key: 0,
                          onInput: ($event: any) => (_ctx.updateSitePermission(prop.row, 'viewer')),
                          value: prop.row.viewer,
                          "onUpdate:value": ($event: any) => ((prop.row.viewer) = $event)
                        }, null, 8, ["onInput", "value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_73, [
                          (prop.row.viewer)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_74))
                            : (_openBlock(), _createElementBlock("i", _hoisted_75))
                        ]))
                  ]))
            ]),
            none: _withCtx((prop) => [
              (prop.row.isSysAdminOnly)
                ? (_openBlock(), _createElementBlock("div", _hoisted_76, "-"))
                : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    (_ctx.isAdmin)
                      ? (_openBlock(), _createBlock(_component_imdex_radio, {
                          key: 0,
                          onInput: ($event: any) => (_ctx.updateSitePermission(prop.row, 'none')),
                          value: prop.row.none,
                          "onUpdate:value": ($event: any) => ((prop.row.none) = $event)
                        }, null, 8, ["onInput", "value", "onUpdate:value"]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                          (prop.row.none)
                            ? (_openBlock(), _createElementBlock("i", _hoisted_79))
                            : (_openBlock(), _createElementBlock("i", _hoisted_80))
                        ]))
                  ]))
            ]),
            site: _withCtx((prop) => [
              _createVNode(_component_imdex_tooltip, {
                nudgeY: -10,
                class: "name-tooltip"
              }, {
                activator: _withCtx((on) => [
                  _createElementVNode("div", _toHandlers(on), [
                    _createElementVNode("span", _hoisted_81, _toDisplayString(prop.row.site) + " " + _toDisplayString(prop.row.isSysAdminOnly
											? _ctx.$t(`userProfile.sysAdminOnly`)
											: ""), 1)
                  ], 16)
                ]),
                tooltip: _withCtx(() => [
                  _createElementVNode("span", {
                    innerHTML: 
									prop.row.site +
									' ' +
									(prop.row.isSysAdminOnly ? _ctx.$t(`userProfile.sysAdminOnly`) : '')
								
                  }, null, 8, _hoisted_82)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }, 8, ["loading", "tableData"]))
        : _createCommentVNode("", true)
    ])
  ]))
}